import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🧠", key: "dontKnowWhereToStart" },
  { emoji: "📦", key: "tooMuchToOrganize" },
  { emoji: "🕳️", key: "missingDetails" },
  { emoji: "⛔", key: "noTime" },
]

export default function CarsBlockerPage() {
  return <RadioCardListPage translationKey="carsBlocker" options={OPTIONS} />
}
